const currentYear = new Date().getFullYear();

const locale = {
    code: "id",
    label: "Bahasa Indonesia",
    NAV_BAR: {
        home: "Beranda",
        homeId: "home",
        aboutus: "Tentang Kami",
        aboutId: "aboutus",
        faq: "FAQ",
        faqId: "faq-section",
        contact: "Kontak",
        contactId: "contact-section",
        button: "Dapatkan Akses Awal",
    },

    HERO: {
        heroHeading: "Menu Anda, dapat diakses segera",
        heroParagraph:
            "Buat, perbarui, dan bagikan menu Anda dengan satu kode QR — tanpa repot, tanpa cetak ulang.",
        button: "Dapatkan Akses Awal",
        downloadText: "Unduh di",
        appStore: "App Store",
        getItOn: "DAPATKAN DI",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "Layanan Kami",
        cards: [
            {
                title: "Buat dan Unggah Menu",
                description:
                    "Buat dan unggah menu Anda dengan mudah hanya dalam beberapa klik! Tambahkan item, atur harga, dan perbarui detail tanpa perlu keahlian teknis.",
            },
            {
                title: "Perbarui Menu",
                description:
                    "Perbarui menu Anda secara real-time kapan saja, di mana saja! Ubah harga, tambahkan hidangan baru, atau arsipkan item yang tidak tersedia secara instan tanpa cetak ulang.",
            },
            {
                title: "Hasilkan dan Bagikan",
                description:
                    "Hasilkan kode QR unik untuk menu Anda secara instan! Bagikan di meja, poster, atau online agar pelanggan dapat memindai dan mengakses menu terbaru Anda.",
            },
        ],
    },

    FEATURES: {
        heading: "Jelajahi Fitur-fitur Hebat Kami",
        lists: [
            {
                title: "Kelola Menu",
                description:
                    "Kelola menu Anda kapan saja! Tambahkan, edit, atau hapus item dengan mudah agar tawaran Anda tetap segar.",
            },
            {
                title: "Wawasan & Laporan",
                description:
                    "Dapatkan wawasan berharga dengan laporan real-time! Lacak tampilan menu, pemindaian QR, dan interaksi pelanggan.",
            },
            {
                title: "Bagikan Kode QR",
                description:
                    "Bagikan menu Anda dengan kode QR unik! Tampilkan di meja, poster, atau online agar pelanggan dapat memindai instan.",
            },
            {
                title: "Ulasan Pelanggan",
                description:
                    "Tampilkan umpan balik pelanggan nyata dan peringkat! Bangun kepercayaan, tingkatkan menu Anda, dan tingkatkan pengalaman makan.",
            },
            {
                title: "Penawaran & Diskon",
                description:
                    "Tingkatkan penjualan dengan penawaran khusus dan diskon! Sorot promosi waktu terbatas dan diskon eksklusif.",
            },
        ],
    },

    ABOUT: {
        heading: "Tentang My QR Menu",
        headingPara: "Permudah manajemen menu restoran Anda dengan pembaruan real-time.",
        highlightHeading: "Akses cepat dan mudah ke semua yang Anda butuhkan",
        highlightPara: "Semua fitur menu Anda — hanya dengan satu ketukan.",
        cards: {
            left: {
                heading: ["Tambahkan bahan dengan mudah", "ke menu QR Anda"],
                alt: "Tambah bahan",
            },
            right: {
                heading: ["Akses dasbor menu", "dengan mudah"],
                alt: "Dasbor menu",
            },
        },
    },

    FAQ: {
        heading: "Anda punya pertanyaan. Kami punya jawaban.",
        subheading: "Semua yang perlu Anda ketahui tentang produk.",
        items: [
            {
                question: "Apa itu My QRMenu?",
                answer:
                    "My QRMenu adalah platform menu digital yang memungkinkan restoran membuat, memperbarui, dan membagikan menu mereka secara instan menggunakan kode QR.",
            },
            {
                question: "Bisakah saya memperbarui menu setelah membuatnya?",
                answer:
                    "Ya, Anda dapat memperbarui menu kapan saja dan itu akan muncul secara instan ketika pelanggan memindai kode QR Anda.",
            },
            {
                question: "Bagaimana My QRMenu bekerja?",
                answer:
                    "Anda membuat menu, menghasilkan kode QR, dan pelanggan memindainya untuk melihat versi terbaru menu Anda.",
            },
            {
                question: "Bagaimana saya membagikan kode QR saya?",
                answer:
                    "Anda dapat membagikan kode QR secara digital atau mencetaknya untuk ditampilkan di restoran Anda.",
            },
            {
                question: "Apakah My QRMenu ramah seluler?",
                answer:
                    "Ya, My QRMenu dioptimalkan untuk semua perangkat, termasuk ponsel dan tablet.",
            },
            {
                question: "Bisakah saya mengumpulkan ulasan pelanggan?",
                answer:
                    "Ya, Anda dapat mengaktifkan ulasan pelanggan dan menggunakan masukan untuk meningkatkan penawaran Anda.",
            },
        ],
    },

    CONTACT: {
        heading: "Hubungi Kami",
        subheading: "Tim kami yang ramah ingin mendengar kabar dari Anda.",
        firstName: "Nama depan",
        lastName: "Nama belakang",
        email: "Email",
        message: "Pesan",
        firstNamePlaceholder: "Nama depan",
        lastNamePlaceholder: "Nama belakang",
        emailPlaceholder: "anda@perusahaan.com",
        messagePlaceholder: "Tulis pesan Anda...",
        privacyConsent: "Anda setuju dengan",
        privacyPolicy: "kebijakan privasi",
        submitButton: "Kirim pesan",
        toast: {
            requiredConsent: "Anda harus menyetujui kebijakan privasi.",
            submitting: "Mengirim pesan...",
            success: "Pesan berhasil dikirim!",
            fail: "Gagal mengirim pesan. Silakan coba lagi.",
            error: "Terjadi kesalahan. Periksa koneksi Anda.",
        },
    },

    HELP_PAGE: {
        title: "Pusat Bantuan",
        description: "Jika Anda memiliki pertanyaan atau membutuhkan dukungan, silakan hubungi kami di ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "Atau lihat FAQ kami di bawah, Anda mungkin menemukan apa yang Anda cari.",
    },

    FOOTER: {
        footerHeading: "Menu digital tanpa batas, disederhanakan!",
        footerButton: "Bergabung dengan daftar tunggu",
        footerConnect: "Terhubung dengan kami",
        footerTerms: "Syarat & Ketentuan",
        footerHelp: "Pusat Bantuan",
        footerPrivacy: "Kebijakan Privasi",
        footerCopyright: `©${currentYear} Semua hak dilindungi.`,
    },

    PRIVACY_POLICY: {
        title: "Kebijakan Privasi",
        lastUpdated: "Terakhir diperbarui: 22 Mei 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                Kebijakan Privasi ini menjelaskan kebijakan dan prosedur Kami mengenai pengumpulan, penggunaan, dan pengungkapan informasi Anda saat Anda menggunakan Layanan.
                </p>
                <p class="mb-6 leading-relaxed">
                Kami menggunakan data pribadi Anda untuk menyediakan dan meningkatkan Layanan. Dengan menggunakan Layanan, Anda menyetujui pengumpulan dan penggunaan informasi sesuai dengan Kebijakan Privasi ini.
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">Interpretasi dan Definisi</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">Interpretasi</h3>
                <p class="mb-6 leading-relaxed">
                    Kata-kata yang huruf pertamanya dikapitalisasi memiliki arti yang ditentukan dalam kondisi berikut.
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">Definisi</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>Akun</strong> berarti akun unik yang dibuat bagi Anda untuk mengakses Layanan kami.</li>
                    <li><strong>Perusahaan</strong> mengacu pada <strong>My QR Menu,</strong> London, Inggris Raya.</li>
                    <li><strong>Data Pribadi</strong> adalah informasi apa pun yang berkaitan dengan individu yang teridentifikasi atau dapat diidentifikasi.</li>
                    <li><strong>Anda</strong> berarti individu yang mengakses atau menggunakan Layanan.</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">Hubungi Kami</h2>
                <p>
                Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, Anda dapat menghubungi kami:
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>Melalui email: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "Syarat dan Ketentuan",
        lastUpdated: "Terakhir diperbarui: 22 Mei 2025",
        content: `
            <p class="leading-relaxed mb-6">
            Harap baca Syarat dan Ketentuan ini dengan saksama sebelum menggunakan Aplikasi atau Situs Web kami.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. Interpretasi dan Definisi</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Interpretasi</h3>
            <p class="leading-relaxed mb-4">
            Kata-kata dengan huruf awal kapital memiliki arti yang ditentukan dalam kondisi berikut.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Definisi</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>Aplikasi</strong> berarti perangkat lunak yang disediakan oleh My QR Menu.</li>
            <li><strong>Perusahaan</strong> mengacu pada My QR Menu, yang berbasis di London, Inggris.</li>
            <li><strong>Layanan</strong> mengacu pada Aplikasi dan Situs Web.</li>
            <li><strong>Anda</strong> berarti individu atau bisnis yang mengakses Layanan.</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. Pengakuan</h2>
            <p class="leading-relaxed mb-6">
            Dengan mengakses atau menggunakan Layanan, Anda setuju untuk terikat oleh Syarat ini. Jika Anda tidak setuju dengan bagian apa pun, Anda tidak boleh mengakses Layanan.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. Tautan ke Situs Web Lain</h2>
            <p class="leading-relaxed mb-6">
            Layanan kami mungkin berisi tautan ke situs web pihak ketiga. Kami tidak bertanggung jawab atas konten atau praktik mereka.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. Pengakhiran</h2>
            <p class="leading-relaxed mb-6">
            Kami berhak untuk mengakhiri atau menangguhkan akses Anda ke Layanan segera, tanpa pemberitahuan sebelumnya, karena alasan apa pun.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. Batasan Tanggung Jawab</h2>
            <p class="leading-relaxed mb-6">
            Sejauh diizinkan oleh hukum, Perusahaan tidak akan bertanggung jawab atas kerusakan apa pun yang timbul dari penggunaan Layanan oleh Anda.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. Penafian "SEBAGAIMANA ADANYA" dan "SEBAGAIMANA TERSEDIA"</h2>
            <p class="leading-relaxed mb-6">
            Layanan disediakan untuk Anda atas dasar "SEBAGAIMANA ADANYA" dan "SEBAGAIMANA TERSEDIA". Kami tidak menjamin bahwa Layanan akan bebas dari kesalahan atau tanpa gangguan.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. Hukum yang Mengatur</h2>
            <p class="leading-relaxed mb-6">
            Syarat ini akan diatur oleh hukum Inggris.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. Penyelesaian Sengketa</h2>
            <p class="leading-relaxed mb-6">
            Jika Anda memiliki sengketa dengan kami, Anda setuju untuk mencoba menyelesaikannya secara informal sebelum mengambil tindakan hukum.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. Untuk Pengguna Uni Eropa (UE)</h2>
            <p class="leading-relaxed mb-6">
            Jika Anda adalah konsumen di UE, Anda berhak atas perlindungan dari ketentuan wajib hukum di negara tempat tinggal Anda.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. Kepatuhan Hukum Amerika Serikat</h2>
            <p class="leading-relaxed mb-6">
            Anda menyatakan dan menjamin bahwa Anda tidak berada di negara yang tunduk pada sanksi pemerintah AS.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. Keterpisahan dan Pengesampingan</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Keterpisahan</h3>
            <p class="leading-relaxed mb-4">
            Jika ada ketentuan dari Syarat ini yang dianggap tidak dapat dilaksanakan, ketentuan lainnya akan tetap berlaku.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Pengesampingan</h3>
            <p class="leading-relaxed mb-6">
            Kegagalan untuk menegakkan suatu ketentuan tidak akan dianggap sebagai pengesampingan hak tersebut.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. Interpretasi Terjemahan</h2>
            <p class="leading-relaxed mb-6">
            Syarat ini mungkin telah diterjemahkan. Jika terjadi sengketa, versi bahasa Inggris yang akan berlaku.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. Perubahan pada Syarat Ini</h2>
            <p class="leading-relaxed mb-6">
            Kami dapat memperbarui Syarat ini kapan saja. Kami akan memberi tahu Anda dengan memposting pemberitahuan di Situs Web kami.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. Hubungi Kami</h2>
            <p class="leading-relaxed mb-2">Jika Anda memiliki pertanyaan tentang Syarat ini, Anda dapat menghubungi kami:</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>Melalui email: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
